import { render, staticRenderFns } from "./bookListWeb.vue?vue&type=template&id=1bd41818&scoped=true&"
import script from "./bookListWeb.vue?vue&type=script&lang=js&"
export * from "./bookListWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd41818",
  null
  
)

export default component.exports